import { Mail, MessageCircle } from "lucide-react";
import { useLanguage } from "@/i18n";
import { BRAND, scrollToSection, whatsappLink } from "@/constants/brand";

export default function Footer() {
  const { t, lang } = useLanguage();
  const waMsg = lang === "pt"
    ? "Olá! Gostaria de falar com a New Era."
    : "Hello! I would like to talk to New Era.";

  return (
    <footer data-testid="footer-main-container" className="border-t border-emerald-500/10 bg-[#020503]">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid gap-12 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-3">
              <img src={BRAND.logo} alt="New Era" className="h-12 w-12 rounded-lg object-cover ring-1 ring-emerald-500/30" />
              <span className="font-display text-xl text-slate-100">
                New <span className="text-neon font-semibold">Era</span>
              </span>
            </div>
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-500">{t("footer.tagline")}</p>
          </div>

          <div>
            <h4 className="font-tech text-xs uppercase tracking-[0.2em] text-emerald-400">{t("footer.servicesTitle")}</h4>
            <ul className="mt-5 space-y-3">
              {t("services.cards").map((s) => (
                <li key={s.id}>
                  <button data-testid={`footer-service-${s.id}`} onClick={() => scrollToSection("servicos")} className="text-sm text-slate-400 transition-colors hover:text-emerald-300">
                    {s.title}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-tech text-xs uppercase tracking-[0.2em] text-emerald-400">{t("footer.contactTitle")}</h4>
            <div className="mt-5 space-y-3">
              <a data-testid="footer-email-link" href={`mailto:${BRAND.email}`} className="flex items-center gap-2.5 text-sm text-slate-400 transition-colors hover:text-emerald-300">
                <Mail className="h-4 w-4 text-emerald-500" />
                {BRAND.email}
              </a>
              <a data-testid="footer-whatsapp-link" href={whatsappLink(waMsg)} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2.5 text-sm text-slate-400 transition-colors hover:text-emerald-300">
                <MessageCircle className="h-4 w-4 text-emerald-500" />
                +55 11 99999-8888
              </a>
              <div className="flex items-center gap-2.5 pt-2">
                <span className="relative flex h-2 w-2">
                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-70" />
                  <span className="relative inline-flex h-2 w-2 rounded-full bg-emerald-400" />
                </span>
                <span className="font-tech text-xs text-slate-500">{t("footer.status")}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-center justify-between gap-4 border-t border-emerald-500/10 pt-8 sm:flex-row">
          <p className="text-center text-xs text-slate-600">{BRAND.legalName}</p>
          <p className="text-xs text-slate-600">© {new Date().getFullYear()} New Era. {t("footer.rights")}</p>
        </div>
      </div>
    </footer>
  );
}
